export const ICECAST_STATUS_URL =
  "https://stream.gluefactoryradio.com/status-json.xsl";

export const ICECAST_STREAM_URL =
  "https://stream.gluefactoryradio.com/stream";

export const ICECAST_MOUNT_PATH = "/stream";

